import React, { createContext, useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import 'assets/css/ToastAnimations.css'; // Додаємо файл CSS для анімацій
import SolarIcon from 'components/icons/SolarIcon';

// Створюємо контекст для Toast
const ToastContext = createContext();
 
export const useToast = () => useContext(ToastContext);
 
export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    // Функція - показує новий тост
    const showToast = (message, type = 'info') => {
        let icon = null;
        switch (type) {
        case 'danger':
            icon = <SolarIcon name="exclamation-octagon" className="me-1" />;
            break;
        case 'success':
            icon = <SolarIcon name="check-circle" className="me-1" />;
            break;
        case 'warning':
            icon = <SolarIcon name="exclamation-triangle" className="me-1" />;
            break;
        default:
            icon = <SolarIcon name="info-circle" className="me-1" />;
        }
  
        // Створюємо новий тост із унікальним nodeRef
        const newToast = {
            id: uuidv4(),
            message,
            type,
            icon,
            nodeRef: React.createRef(), // використання createRef замість useRef
        };

        setToasts((prevToasts) => [...prevToasts, newToast]);
    };

    // Функція для закриття тосту
    const closeToast = (id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <ToastContainer position="bottom-center" className="p-3" style={{position:'fixed'}}>
                <TransitionGroup>
                    {toasts.map((toast) => (
                        <CSSTransition
                            key={toast.id}
                            timeout={300}
                            classNames="toast"
                            // передаємо nodeRef
                            nodeRef={toast.nodeRef}>
                            <Toast  
                                ref={toast.nodeRef} // встановлюємо ref для Toast
                                className={`bg-${toast.type} text-white rounded border-${toast.type} mb-2`}
                                onClose={() => closeToast(toast.id)}
                                show={true}
                                autohide
                                delay={6000}>

                                <Toast.Body className="d-flex justify-content-between">
                                    <div>
                                        {toast.icon}
                                        {toast.message}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white text-white"
                                        onClick={() => closeToast(toast.id)}
                                    ></button>
                                </Toast.Body>
                            </Toast>
                        </CSSTransition>
                    ))}
                </TransitionGroup>
            </ToastContainer>
        </ToastContext.Provider>
    );
};
